import api from './api';

const permissionsService = {
  // Obter todas as permissões de todos os roles
  getAllRolesPermissions: async () => {
    try {
      const response = await api.get('/permissions/all');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar permissões:', error);
      throw error;
    }
  },

  // Obter permissões de um role específico
  getRolePermissions: async (role) => {
    try {
      const response = await api.get(`/permissions/role/${role}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar permissões do role:', error);
      throw error;
    }
  },

  // Obter permissões disponíveis (mapeamento)
  getAvailablePermissions: async () => {
    try {
      const response = await api.get('/permissions/available');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar permissões disponíveis:', error);
      throw error;
    }
  },

  // Atualizar permissões de um role
  updateRolePermissions: async (role, permissions) => {
    try {
      const response = await api.put(`/permissions/role/${role}`, { permissions });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar permissões:', error);
      throw error;
    }
  },

  // Resetar permissões de um role para o padrão
  resetRolePermissions: async (role) => {
    try {
      const response = await api.post(`/permissions/role/${role}/reset`);
      return response.data;
    } catch (error) {
      console.error('Erro ao resetar permissões:', error);
      throw error;
    }
  }
};

export default permissionsService;

